"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocale = void 0;
const is_preview_1 = require("./is-preview");
const locale_1 = require("./constants/locale");
const LOCALE_HEADER = 'x-locale';
// eslint-disable-next-line
const localeFromHeader = (req) => {
    const { headers = {} } = req;
    return locale_1.Locale[headers[LOCALE_HEADER]];
};
const localeFromHostname = (host) => {
    let hostName;
    // if the hostName has a dot in it, we know we are dealing with a domain name
    if (host && host.includes('.')) {
        hostName = host.slice(-2);
    }
    else {
        // we are on localhost, fallback to default host
        hostName = locale_1.DEFAULT_HOST;
    }
    return locale_1.HostLocaleMap[hostName.toLowerCase()];
};
/**
 * Get the locale code from request header or from host or default
 * @param req request
 * @param host host string
 * @returns locale code from Locale string or default locale code as nl-NL
 * @default 'nl_NL'
 * @example
 * getLocale({ headers: { 'x-locale': 'nl_NL'}}, '')
 * //=> 'nl_NL'
 *
 * @example
 * getLocale({ headers: {}}, 'ah.be')
 * //=> 'nl_BE'
 *
 * @example
 * getLocale('')
 * //=> 'nl_NL'
 */
// eslint-disable-next-line
const getLocale = (req, host) => {
    if ((0, is_preview_1.isPreview)(req)) {
        return req.query.locale;
    }
    return localeFromHeader(req) || localeFromHostname(host);
};
exports.getLocale = getLocale;
